import React from "react";
import { ShopifyProduct, SellingPlan, ShopifyVariant } from "@/types";
import QuantityStepper from "./atomic/QuantityStepper";
import AddToCartButton from "./atomic/AddToCartButton";

interface ProductCardProps {
  product: ShopifyProduct;
  selectedVariantId: string;
  currentQuantity: number;
  selectedSellingPlanId?: string;
  onVariantChange: (variantId: string) => void;
  onQuantityChange: (change: number) => void;
  onSellingPlanChange: (sellingPlanId: string) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  selectedVariantId,
  currentQuantity,
  selectedSellingPlanId,
  onVariantChange,
  onQuantityChange,
  onSellingPlanChange,
}) => {
  // Get the selected variant details
  const selectedVariant = product.variants.edges.find(
    (variant) => variant.node.id === selectedVariantId
  )?.node;

  // Get all selling plans from this product
  const sellingPlans: SellingPlan[] = [];
  if (product.sellingPlanGroups?.edges) {
    product.sellingPlanGroups.edges.forEach((group) => {
      group.node.sellingPlans.edges.forEach((plan) => {
        sellingPlans.push(plan.node);
      });
    });
  }

  return (
    <div className="product-card">
      <div className="product-image">
        {product.images.edges[0] && (
          <img
            src={product.images.edges[0].node.url}
            alt={product.images.edges[0].node.altText || product.title}
          />
        )}
      </div>
      <div className="product-info">
        <h3 className="product-title">{product.title}</h3>
        <p className="product-price">
          $
          {selectedVariant?.price.amount ||
            product.priceRange.minVariantPrice.amount}
        </p>
        <div className="product-actions">
          <div className="product-dropdowns">
            {product.variants.edges.length > 1 ? (
              <select
                className="variant-select"
                value={selectedVariantId}
                onChange={(e) => onVariantChange(e.target.value)}
              >
                {product.variants.edges.map(
                  (variant: { node: ShopifyVariant }) => (
                    <option key={variant.node.id} value={variant.node.id}>
                      {variant.node.title}
                    </option>
                  )
                )}
              </select>
            ) : null}

            {sellingPlans.length > 0 && (
              <select
                className="selling-plan-select"
                value={selectedSellingPlanId || ""}
                onChange={(e) => onSellingPlanChange(e.target.value)}
              >
                <option value="">One-time</option>
                {sellingPlans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {currentQuantity === 0 ? (
            <AddToCartButton onAddToCart={() => onQuantityChange(1)} />
          ) : (
            <QuantityStepper
              quantity={currentQuantity}
              onIncrement={() => onQuantityChange(1)}
              onDecrement={() => onQuantityChange(-1)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
